var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { CLAIM_STATUS_TRAD_KEYS, getAllStatuses } from '@backoffice/claim/status';
import { ClaimTypeTrigram } from '@shared/types/api/claim';
import { translateChoices } from '@shared/choice';
import { UserRole } from '@shared/types/api/user';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claims = namespace('claims');
let CountingListFilters = class CountingListFilters extends Vue {
    constructor() {
        super(...arguments);
        this.isSearchable = false;
    }
    mounted() {
        if (Object.values(this.filters).some((val) => typeof val !== 'undefined')) {
            this.isSearchable = true;
        }
    }
    get isSupervisor() {
        var _a, _b;
        if ((_a = this.$auth.user) === null || _a === void 0 ? void 0 : _a.profile)
            return ((_b = this.$auth.user) === null || _b === void 0 ? void 0 : _b.profile) === 'superviseur';
        return this.$hasAccessLevel(UserRole.MANAGER_READONLY);
    }
    get searchable() {
        return this.isSearchable;
    }
    set searchable(value) {
        this.isSearchable = value;
        if (!value && Object.values(this.filters).some((val) => typeof val !== 'undefined')) {
            this.resetFilters();
            this.filter(this.filters);
        }
    }
    get from() {
        return this.filters.from ? new Date(this.filters.from.toString()) : undefined;
    }
    set from(from) {
        var _a;
        this.filter({ ...this.filters, from: (_a = from === null || from === void 0 ? void 0 : from.toISOString()) !== null && _a !== void 0 ? _a : undefined });
    }
    get to() {
        return this.filters.to ? new Date(this.filters.to.toString()) : undefined;
    }
    set to(to) {
        var _a;
        this.filter({ ...this.filters, to: (_a = to === null || to === void 0 ? void 0 : to.toISOString()) !== null && _a !== void 0 ? _a : undefined });
    }
    get type() {
        return this.filters.type ? this.filters.type.toString() : undefined;
    }
    set type(type) {
        var _a;
        this.filter({ ...this.filters, type: (_a = type === null || type === void 0 ? void 0 : type.toString()) !== null && _a !== void 0 ? _a : undefined });
    }
    get caseNumber() {
        return this.filters.caseNumber ? this.filters.caseNumber.toString() : undefined;
    }
    set caseNumber(caseNumber) {
        this.filter({ ...this.filters, caseNumber });
    }
    get valuationAmountFrom() {
        return typeof this.filters.valuationAmountFrom === 'number'
            ? this.filters.valuationAmountFrom / 100
            : undefined;
    }
    set valuationAmountFrom(value) {
        const valuationAmountFrom = value ? value * 100 : undefined;
        this.filter({ ...this.filters, valuationAmountFrom });
    }
    get valuationAmountTo() {
        return typeof this.filters.valuationAmountTo === 'number'
            ? this.filters.valuationAmountTo / 100
            : undefined;
    }
    set valuationAmountTo(value) {
        const valuationAmountTo = value ? value * 100 : undefined;
        this.filter({ ...this.filters, valuationAmountTo });
    }
    get entity() {
        return this.filters.entity ? this.filters.entity.toString() : undefined;
    }
    set entity(entity) {
        this.filter({ ...this.filters, entity });
    }
    get manager() {
        return this.filters.manager ? this.filters.manager.toString() : undefined;
    }
    set manager(manager) {
        this.filter({ ...this.filters, manager });
    }
    get claimTypeOptions() {
        return Object.values(ClaimTypeTrigram)
            .filter((trigram) => trigram !== ClaimTypeTrigram.Empty)
            .filter((trigram) => {
            if (!insurerHasFeature(InsurerFeatureFlag.BackOfficeClaimTypesFilter))
                return true;
            return insurerHasFeature(InsurerFeatureFlag.BackOfficeClaimTypesFilter, trigram);
        })
            .map((trigram) => {
            return { value: trigram, label: this.$tc(`claim.type.${trigram}`) };
        });
    }
    claimStatusFilterLabel() {
        const statusList = this.filters.status;
        if (!(statusList === null || statusList === void 0 ? void 0 : statusList.length))
            return '';
        const statuses = statusList.map((status, i) => {
            const label = this.$tc(CLAIM_STATUS_TRAD_KEYS[status]);
            if (i > 0)
                return label.toLowerCase();
            return label;
        });
        if (statuses.length === 1)
            return statuses[0];
        else
            return `(${statuses.length}) ${statuses.join(', ')}`;
    }
    get claimStatusOptions() {
        return translateChoices(getAllStatuses(this.$config.insurerConfig), this.$i18n.tc.bind(this.$i18n)).sort((a, b) => a.label.localeCompare(b.label));
    }
};
__decorate([
    claims.State('filters')
], CountingListFilters.prototype, "filters", void 0);
__decorate([
    claims.Action('filter')
], CountingListFilters.prototype, "filter", void 0);
__decorate([
    claims.Action('loadClaims')
], CountingListFilters.prototype, "loadClaims", void 0);
__decorate([
    claims.Mutation('RESET_FILTERS')
], CountingListFilters.prototype, "resetFilters", void 0);
CountingListFilters = __decorate([
    Component({
        async fetch() {
            await this.loadClaims();
        },
    })
], CountingListFilters);
export default CountingListFilters;
